import React from 'react';
import PropTypes from 'prop-types';
import TablePagination from '@material-ui/core/TablePagination';

export default class EnhancedTablePagination extends React.Component {
  render() {
    const { data, rowsPerPage, page, handleChangePage, handleChangeRowsPerPage } = this.props;

    return (
      <TablePagination
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'Previous Page',
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page',
        }}
        onChangePage={(e, page)=>{handleChangePage(e, page)}}
        onChangeRowsPerPage={(e)=>{handleChangeRowsPerPage(e)}}
      />
    );
  }
}

EnhancedTablePagination.propTypes = {
  data: PropTypes.array.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Table/EnhancedTablePagination.js